<div class="container margin-nav mat-elevation-z8">
  <app-titulo
    *ngIf="campanhaSelecionada !== null && campanhaSelecionada !== undefined"
    [titulo]="titulo"
  ></app-titulo>
  <form class="formContainer" [formGroup]="formulario" (ngSubmit)="onSubmit()">
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Nome do Cooperado</mat-label>
        <div class="busca">
          <input
            matInput
            id="inputCooperado"
            formControlName="nome"
            (keyup)="searchCooperado($event.target.value)"
          />
          <mat-icon (click)="pesquisaCooperado()">search</mat-icon>
        </div>
      </mat-form-field>
      <mat-form-field class="grow1" appearance="outline">
        <mat-label>CPF / CNPJ</mat-label>
        <input
          matInput
          #inputCPF
          type="text"
          formControlName="cpf_cnpj"
          appCpfCnpjMask
        />
        <mat-error *ngIf="formulario.get('cpf_cnpj').hasError('cpfNotValid')">
          CPF/CNPJ inválido
        </mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>e-mail</mat-label>
        <input matInput #inputEmail formControlName="email" />
      </mat-form-field>
      <mat-form-field class="grow1" appearance="outline">
        <mat-label>Telefone</mat-label>
        <input
          matInput
          #inputTelefone
          type="tel"
          [mask]="'(00) 00000-0000'"
          formControlName="telefone"
          maxlength="15"
        />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field class="grow1" appearance="outline">
        <mat-label>Código PA</mat-label>
        <mat-select #Agencia formControlName="agencia">
          <combo-search #searcherAgencia [itens]="agencias" [filtroCtrl]="filtroAgenciaCtrl" [searchProperty]="'codPA'"></combo-search>
          <mat-option *ngFor="let pa of searcherAgencia.itensFiltrados | async" [value]="pa.codPA">{{ pa.codPa }} - {{ pa.cidade }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Produto</mat-label>
        <mat-select #Produto formControlName="produtoId">
          <combo-search #searcherProduto [itens]="produtos" [filtroCtrl]="filtroProdutoCtrl" [searchProperty]="'descricao'"></combo-search>
          <mat-option *ngFor="let p of searcherProduto.itensFiltrados | async" [value]="p.id">{{ p.descricao }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="grow1" appearance="outline">
        <mat-label>Conta</mat-label>
        <input matInput #inputConta formControlName="conta" />
      </mat-form-field>
      <mat-form-field class="grow1" appearance="outline">
        <mat-label>Quantidade</mat-label>
        <input
          matInput
          #inputQuantidade
          type="number"
          formControlName="quantidade"
        />
      </mat-form-field>
    </div>
    <div class="row">
      <mat-form-field appearance="outline">
        <mat-label>Colaborador</mat-label>
        <mat-select #Colaborador formControlName="idColaborador">
          <combo-search #searcherColaborador [itens]="usuarios" [filtroCtrl]="filtroColaboradorCtrl" [searchProperty]="'nome'"></combo-search>
          <mat-option *ngFor="let usuario of searcherColaborador.itensFiltrados | async" [value]="usuario.id">{{ usuario.nome }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-accordion
        class="headers-align mat-elevation-z8"
        *ngIf="contasDoCooperado?.length >= 1"
      >
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title> Contas Bancárias </mat-panel-title>
            <mat-panel-description>
              Contas ativas do Cooperado
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div *ngFor="let conta of contasDoCooperado" class="cupom-contas">
            <label>Número: {{ conta.numeroConta }}</label>
            <label>PA: {{ conta.codPA }}</label>
            <label>Modalidade: {{ conta.modalidade }}</label>
            <label>Tipo: {{ conta.tipo }}</label>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div class="item-right">
      <button
        mat-button
        class="btnOK mat-elevation-z8"
        [disabled]="formulario.status == 'INVALID' || formulario.pristine"
        type="submit"
      >
        Salvar
      </button>
      <button
        mat-button
        class="btnCancel mat-elevation-z8"
        type="button"
        (click)="cancelar()"
      >
        Cancelar
      </button>
    </div>
  </form>
</div>
